export function OutlineCotizadorIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0311 21.0015H6.00177C4.89768 21.0015 4 20.1038 4 18.9997V5.00177C4 3.89768 4.89768 3 6.00177 3H16.049C17.1483 3 18.0412 3.88807 18.0508 4.98737V9.00051"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03198 15H11.0322"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03198 11.002H14.0325"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03198 6.99805H14.0325"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0334 14.5014C19.6109 14.199 18.7228 13.6565 17.5323 13.6661C17.0379 13.6661 15.8186 13.6805 15.3338 14.5014C15.0745 14.943 15.0121 15.6439 15.3338 16.1672C16.1738 17.5401 18.8909 16.4648 19.7309 17.8329C20.0478 18.3513 19.995 19.057 19.7309 19.4986C19.2653 20.2907 18.1132 20.3195 17.6091 20.3339C16.3946 20.3627 15.4682 19.8107 15.0361 19.4986"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
      <path d="M17.5322 12V13.6657" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M17.5322 20.334V21.9997" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
}
